import React, { useState, useEffect } from "react";
import {
  usePrepareContractWrite,
  useContractWrite,
  useWaitForTransaction,
  useContractEvent,
} from "wagmi";
import {
  MASTERCLASS_ABI,
  MASTERCLASS_CONTRACT,
} from "../../components/materclasscontract";
import { usdtabi } from "../../components/content/usdtabi";
import {
  prepareWriteContract,
  writeContract,
  readContract,
  waitForTransaction,
} from "@wagmi/core";
import {
  Button,
  TextField,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { utils } from "ethers";
import { watchContractEvent } from "@wagmi/core";
import axios from "axios";
import { SnackbarProvider, VariantType, useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import Web3 from "web3";

const useStyles = makeStyles((theme) => ({
  nft_buttons: {
    background: "#d8ca93 !important",
    color: "white",
  },
}));

const loadingStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
};

export function MintCardNFTs({ walletAddress, card, totalmaxsupply }) {
  const navigate = useNavigate();
  const [loadingMint, setloadingMint] = useState(false);
  const [mintMessage, setmintMessage] = useState("");
  const [usdtisapproved, setusdtisapproved] = useState(false);
  const [usdtApproved, setusdtApproved] = useState(0);

  const { enqueueSnackbar } = useSnackbar();
  console.log("MindCardNFT");
  const classes = useStyles();
  console.log("walletAddress", walletAddress);
  console.log("card", card);

  const isapproved = async () => {
    try {
      const allowance = await readContract({
        address: "0x55d398326f99059fF775485246999027B3197955",
        abi: usdtabi,
        functionName: "allowance",
        args: [walletAddress, MASTERCLASS_CONTRACT],
      });
      console.log("allowance:", allowance);
      setusdtApproved(allowance);
    } catch (error) {
      console.error(error);
    }
  };

  let NFT_CONTRACT;
  let MINT_AMOUNT;
  if (card === 1) {
    NFT_CONTRACT = MASTERCLASS_CONTRACT;
    MINT_AMOUNT = 100;
  } else if (card === 2) {
    NFT_CONTRACT = MASTERCLASS_CONTRACT;
    MINT_AMOUNT = 400;
  } else if (card === 3) {
    NFT_CONTRACT = MASTERCLASS_CONTRACT;
    MINT_AMOUNT = 2000;
  }

  const handleMintButton = async () => {
    console.log("handleMintButton");
    isapproved();
  };

  useEffect(() => {
    if (usdtApproved >= Web3.utils.toWei(String(MINT_AMOUNT), "ether")) {
      console.log("enough usdt approved");
      setusdtisapproved(true);
    } else {
      console.log("not enough usdt approved");
      setusdtisapproved(false);
      approveusdt?.();
    }
  }, [usdtApproved]);

  const { config } = usePrepareContractWrite({
    address: NFT_CONTRACT,
    abi: MASTERCLASS_ABI,
    functionName: "mint",
    args: [totalmaxsupply],
    account: walletAddress,
  });
  const { data, write } = useContractWrite(config);

  //WEB3 COMPONENTS
  //PREPARE APPROVE USDT
  const { config: usdtconfig } = usePrepareContractWrite({
    address: "0x55d398326f99059fF775485246999027B3197955",
    abi: usdtabi,
    functionName: "approve",
    args: [NFT_CONTRACT, Web3.utils.toWei(String(MINT_AMOUNT), "ether")],
    account: walletAddress,
    onError(error) {
      let errorstring = JSON.stringify(error);
      // console.log("usdtconfig usePrepareContractWrite", errorstring);
    },
    onSuccess(data) {
      // console.log("usdtconfig Success usePrepareContractWrite", data);
    },
  });
  // console.log("usdtconfig", usdtconfig);
  const {
    write: approveusdt,
    data: approvedata,
    error: errorapprove,
    isLoading: isLoadingapprove,
    isError: isErrorapprove,
  } = useContractWrite(usdtconfig);

  const {
    data: approvedatareceipt,
    isLoading: approveisPending,
    isSuccess: approveisSuccess,
  } = useWaitForTransaction({
    hash: approvedata?.hash,
    onSuccess(data) {
      enqueueSnackbar("USDT Approval Successful!", {
        variant: "success",
      });
      console.log("Success Approve", data);
      setusdtisapproved(true);
    },
  });

  return (
    <div>
      {loadingMint ? (
        <Box className={`${loadingStyle} text-center mt-3`}>
          <CircularProgress />
          <Typography variant="h6" style={{ width: "max-content" }}>
            {mintMessage}
          </Typography>
        </Box>
      ) : (
        <Button
          className={classes.nft_buttons + " mt-3"}
          style={{ marginBottom: "20px", maxHeight: "33px" }}
          fullWidth={true}
          variant="contained"
          onClick={() => handleMintButton()}
        >
          BUY / Mint
        </Button>
      )}
    </div>
  );
}

export default MintCardNFTs;
